import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { environment } from 'env/environment';
import { HttpHeaders } from '@angular/common/http';
import { UserBookStatisticsWeekly } from 'bookraw/shared/models/user-book-statistics-weekly.model';

@Injectable()
export class UserBookStatisticsService extends ListService<UserBookStatisticsWeekly> {

  url: string = '/api/admin/statistics/userBooks';

  export( userIds: string) {
    const tmpQuery = this.queryParams;
    tmpQuery.setQueryParam('limit', null);
    tmpQuery.setQueryParam('offset', null);

    const headers = new HttpHeaders().set('Accept', 'application/vnd.ms-excel');
    return this.http.get(environment.baseURL + this.url + '/export' + tmpQuery.paramString, {
      headers, observe: 'response', params: { userIds }, responseType: 'blob'
    });
  }
}
